import { o_util } from "../chunks/common-namespaces-client-CHyZgmlk.mjs";
import { otto } from "../chunks/common-nexus-client-BxVeVD8v.mjs";
import { asExport } from "../chunks/common-core-client-BYCqsbss.mjs";
import { noop } from "../chunks/common-function-client-BVBvJr6Z.mjs";
const navigationSync = /*           */ asExport(o_util, "navigation", {});
const paramsMap = /*           */ asExport(
  navigationSync,
  "paramsMap",
  noop
);
const stateMap = /*           */ asExport(
  navigationSync,
  "stateMap",
  noop
);
const navigation = /*           */ asExport(otto, "navigation", {});
const scope = /*           */ asExport(navigation, "scope", noop);
const current = /*           */ asExport(navigation, "current", {});
const currentHash = /*           */ asExport(
  navigation,
  "currentHash",
  {}
);
const currentSearch = /*           */ asExport(
  navigation,
  "currentSearch",
  {}
);
const currentState = /*           */ asExport(
  navigation,
  "currentState",
  {}
);
const currentUrl = /*           */ asExport(
  navigation,
  "currentUrl",
  {}
);
const hashParams = /*           */ asExport(
  navigation,
  "hashParams",
  noop
);
const searchParams = /*           */ asExport(
  navigation,
  "searchParams",
  noop
);
const onNavigate = /*           */ asExport(
  navigation,
  "onNavigate",
  {}
);
const navigate = /*           */ asExport(
  navigation,
  "navigate",
  noop
);
export {
  current,
  currentHash,
  currentSearch,
  currentState,
  currentUrl,
  hashParams,
  navigate,
  navigation,
  navigationSync,
  onNavigate,
  paramsMap,
  scope,
  searchParams,
  stateMap
};
/*                                          */
